import React from 'react';
import { FiDownload, FiArrowLeft } from 'react-icons/fi';

const Resume = () => {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/Akash.pdf';
    link.download = 'Akash_Perumal_Resume.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-blue-950 to-slate-950">
      {/* Navigation */}
      <nav className="fixed top-0 w-full z-50 bg-slate-950/90 backdrop-blur-xl border-b border-blue-500/20 shadow-lg shadow-blue-500/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="text-2xl font-bold text-white" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
            </div>
            
            <a 
              href="/" 
              className="flex items-center space-x-2 text-slate-200 hover:text-blue-400 transition-colors"
            >
              <FiArrowLeft className="w-5 h-5" />
              <span style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>Back to Home</span>
            </a>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <div className="pt-20 pb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl lg:text-6xl font-bold text-white mb-6" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
              My <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">Resume</span>
            </h1>
            <p className="text-lg text-gray-400 max-w-2xl mx-auto" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
              Download my resume to learn more about my experience, skills, and achievements
            </p>
          </div>

          {/* Resume Container */}
          <div className="bg-black/20 backdrop-blur-sm rounded-2xl border border-white/10 p-8 mb-8">
            <div className="flex flex-col lg:flex-row items-center justify-between mb-8">
              <div className="text-center lg:text-left mb-6 lg:mb-0">
                <h2 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
                  Akash Perumal
                </h2>
                <p className="text-gray-400" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
                  The Versatile Developer
                </p>
              </div>
              
              <button
                onClick={handleDownload}
                className="flex items-center space-x-3 px-6 py-3 bg-gradient-to-r from-blue-600 to-cyan-600 text-white font-semibold rounded-full hover:shadow-lg hover:shadow-blue-500/25 transition-all duration-300 transform hover:scale-105"
                style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}
              >
                <FiDownload className="w-5 h-5" />
                <span>Download Resume</span>
              </button>
            </div>

            {/* PDF Viewer */}
            <div className="bg-white rounded-lg overflow-hidden shadow-2xl">
              <iframe
                src="/Akash.pdf#toolbar=1&navpanes=1&scrollbar=1"
                className="w-full h-[800px] lg:h-[1000px]"
                title="Akash Perumal Resume"
              />
            </div>
          </div>

          {/* Additional Info */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-black/20 backdrop-blur-sm rounded-xl p-6 border border-white/10">
              <h3 className="text-xl font-bold text-white mb-3" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
                Quick Overview
              </h3>
              <p className="text-gray-400 text-sm" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
                Tech enthusiast with expertise in React.js, Python, AWS, Docker, and automated testing.
              </p>
            </div>
            
            <div className="bg-black/20 backdrop-blur-sm rounded-xl p-6 border border-white/10">
              <h3 className="text-xl font-bold text-white mb-3" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
                Experience
              </h3>
              <p className="text-gray-400 text-sm" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
                Evolved from manual testing to full-stack development with hands-on experience in various technologies.
              </p>
            </div>
            
            <div className="bg-black/20 backdrop-blur-sm rounded-xl p-6 border border-white/10">
              <h3 className="text-xl font-bold text-white mb-3" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
                Contact
              </h3>
              <p className="text-gray-400 text-sm" style={{ fontFamily: 'SF Pro, Inter, sans-serif' }}>
                Ready to discuss opportunities and collaborate on exciting projects.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resume;
